import { dispatchRootEvent, Editor, Transforms } from '@tunasong/plugin-lib'
import type { TunaEditor } from '@tunasong/plugin-lib'
import type { NodeEntry } from 'slate'

/**
 * "Show in song" (chat makeover M3, #2718): put the caret in the block, scroll it into view and open its comments,
 * which is where a reply to the group is written. Returns false when the block is no longer in the document.
 */
export const showBlockComments = (editor: TunaEditor, blockId: string) => {
  const [entry] = Editor.nodes(editor, {
    at: [],
    match: node => (node as { id?: unknown }).id === blockId && 'children' in node,
  })
  if (!entry) {
    return false
  }
  const [, path] = entry
  Transforms.select(editor, Editor.start(editor, path))
  document.querySelector(`[data-block-id="${CSS.escape(blockId)}"]`)?.scrollIntoView({ block: 'center' })
  /** The popup anchors at the DOM caret, which reaches the block once the new selection has rendered */
  requestAnimationFrame(() => dispatchRootEvent(editor, entry as NodeEntry, 'show-comments'))
  return true
}
